// extracted by mini-css-extract-plugin
export default {"cardContainer":"RecentPost_cardContainer__7jf7o","cardTitle":"RecentPost_cardTitle__yY3e0","cardDes":"RecentPost_cardDes__0XVM+"};